import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import {
    Container,
    Box,
    Paper,
    Tooltip,
    Typography,
    FormControl,
    InputLabel,
    CircularProgress,
    Select,
    MenuItem, Modal,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,

    DialogContentText,

    IconButton,
    InputAdornment,
} from '@mui/material';


import { styled } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import AddVehicle from './AddVehicle';
import EditVehicle from './EditVehicle';
import base64 from "base64-js";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const StyledHeader = styled(Box)(({ theme }) => ({
    border: "1px solid #CC9966",
    borderRadius: "8px",
    height: "60px",
    background: "linear-gradient(90deg, #beab6c 0%, #d4c28a 100%)",
    display: "flex",
    alignItems: "center",
    padding: "0 20px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    marginBottom: "20px",
}));
const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: "4px",
    padding: "8px 16px",
    textTransform: "none",
    fontWeight: 600,
}));

const ManageVehicle = () => {

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [openDeleteSnackbar, setOpenDeleteSnackbar] = useState(false);


    const [showUserGuide, setShowUserGuide] = useState(false);
    // Data states
    const navigate = useNavigate();
    const { encodedFormId } = useParams();
    const [branch, setBranch] = useState([]);
    const [vehicleType, setVehicleType] = useState([]);
    // const [driverList, setDriverList] = useState([]);
    const [vehicles, setVehicles] = useState([]);

    const [loadingBarProgress, setLoadingBarProgress] = useState(0);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [authorization, setAuthorization] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // UI states
    const [view, setView] = useState("list"); // "list", "add", or "edit"
    const [editingVehicle, setEditingVehicle] = useState(null);

    // Decode the encodedFormId
    const decodeFormId = (encodedFormId) => {
        const bytes = base64.toByteArray(encodedFormId);
        return new TextDecoder().decode(bytes);
    };
    const formId = decodeFormId(encodedFormId);

    // Filters
    const [filters, setFilters] = useState({
        searchTerm: '',
        branchId: '',
        isActive: ''
    });

    // Pagination
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    // Dialogs
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [vehicleToDelete, setVehicleToDelete] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");

    // Load initial data
    useEffect(() => {
        fetchBranch();
        fetchVehicleType();
        // fetchDrivers();
        fetchVehicles();
        Authorizer();
    }, []);

    const Authorizer = async () => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            setLoadingBarProgress(30);
            const token = sessionStorage.getItem("token");
            console.log("Sending decoded formId:", formId);

            const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify({
                    formId,
                }),
            });

            if (response.ok) {
                const responseData = await response.json();
                setAuthorization(responseData);
                const authorizationData = responseData[0];
                setCanDelete(authorizationData.uDelete === 1);
                setCanEdit(authorizationData.uModify === 1);
                setLoadingBarProgress(100);
            } else {
                console.error("Authorization failed:", response.status);
                // alert("Invalid authorization response");
                setSnackbarMessage("Invalid authorization response");
                setSnackbarSeverity("error");
                setSnackbarOpen(true);
                setLoadingBarProgress(0);
            }
        } catch (error) {
            console.error("API request error:", error);
            // alert("An error occurred. Please try again later.");
            setSnackbarMessage("An error occurred. Please try again later.");
                setSnackbarSeverity("error");
                setSnackbarOpen(true);
            setLoadingBarProgress(0);
        }
    };

    // Fetchers
    const fetchBranch = async () => {
        try {
            setIsLoading(true); // Start loading
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: sessionStorage.getItem("token"),
                },
            });
            if (response.ok) {
                const responseData = await response.json();
                setBranch(responseData);
            }
        } catch (error) {
            console.error("Error fetching branch:", error);
        } finally {
            setIsLoading(false); // Stop loading
        }
    };


    const handleDisable = async (vehicle) => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const regNo = encodeURIComponent(vehicle.registrationNo);
            const url = `${apiUrl}/Transportation/VehicleMaster/DisableVehicle/${regNo}`;

            const response = await fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: sessionStorage.getItem('token'),
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            showSnackbar("Vehicle deactivated!", "success");
            fetchVehicles();
        } catch (err) {
            console.error("Error disabling vehicle:", err);
            showSnackbar("Failed to deactivate vehicle.", "error");
        }
    };



    const fetchVehicleType = async () => {
        try {
            setIsLoading(true); // Start loading
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const response = await fetch(`${apiUrl}/Vehicle/GetVehicleType`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: sessionStorage.getItem("token"),
                },
            });
            if (response.ok) {
                const responseData = await response.json();
                setVehicleType(responseData);
            }
        } catch (error) {
            console.error("Error fetching vehicle type:", error);
        } finally {
            setIsLoading(false); // Stop loading
        }
    };


    // const fetchDrivers = async () => {
    //     try {
    //         const apiUrl = process.env.REACT_APP_BASE_URL;
    //         const response = await fetch(`${apiUrl}/DriverMappingVehicle/GetDriversName`, {
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 Authorization: sessionStorage.getItem("token"),
    //             },
    //         });
    //         if (response.ok) {
    //             const responseData = await response.json();
    //             setDriverList(responseData.driverNames);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching drivers:", error);
    //     }
    // };

    const fetchVehicles = async () => {
        try {
            setIsLoading(true); // Start loading
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const response = await fetch(`${apiUrl}/Transportation/VehicleMaster/GetVehicleMaster`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: sessionStorage.getItem("token")
                }
            });
            if (response.ok) {
                const data = await response.json();
                setVehicles(data);
            } else {
                showSnackbar("Failed to load vehicles.", "error");
            }
        } catch (error) {
            console.error("Error fetching vehicles:", error);
            showSnackbar("Network error.", "error");
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    const handleEdit = (vehicle) => {
        navigate(`/manage-vehicle/edit/${vehicle.vechileID}`, {
            state: {
                vehicle,
                vehicleType, // assuming it's available in this scope
                // driverList, // optionally include this if needed
            }
        });
    };

    const handleDeleteClick = (vehicle) => {
        if (!canDelete) {
            // alert("You don’t have permission to delete vehicles.");
            setSnackbarMessage("You don’t have permission to delete vehicles.");
                setSnackbarSeverity("warning");
                setSnackbarOpen(true);
            return;
        }

        setVehicleToDelete(vehicle);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = async () => {
        if (!vehicleToDelete) return;

        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const response = await fetch(
                `${apiUrl}/Transportation/VehicleMaster/Id?Id=${vehicleToDelete.vechileID}`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: sessionStorage.getItem("token"),
                    },
                }
            );

            if (response.ok) {
                setVehicles((prev) =>
                    prev.filter((v) => v.vechileID !== vehicleToDelete.vechileID)
                );
                setSnackbarMessage('Vehicle deleted successfully!');
                setOpenDeleteSnackbar(true);

            } else {
                showSnackbar("Failed to delete vehicle.", "error");
            }
        } catch (error) {
            console.error("Error deleting vehicle:", error);
            showSnackbar("An error occurred while deleting the vehicle.", "error");
        } finally {
            setDeleteDialogOpen(false);
            setVehicleToDelete(null); // Optional: clear the state
        }
    };

    const handleDeleteCancel = () => {
        setVehicleToDelete(null);
        setDeleteDialogOpen(false);
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const filteredVehicles = Array.isArray(vehicles)
        ? vehicles.filter(v =>
            (filters.searchTerm === '' ||
                v.vechileNo.toLowerCase().includes(filters.searchTerm.toLowerCase()) ||
                v.make.toLowerCase().includes(filters.searchTerm.toLowerCase())
            ) &&
            (filters.branchId === '' || v.branchId === parseInt(filters.branchId)) &&
            (filters.isActive === '' || v.vechileOn === (filters.isActive === 'true'))
        )
        : [];

    const showSnackbar = (message, severity) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const closeSnackbar = () => {
        setSnackbarOpen(false);
    };

    const handleSaveSuccess = (message) => {
        showSnackbar(message, "success");
        fetchVehicles();
        setView("list");
        setEditingVehicle(null);
    };

    const handleSaveError = (message) => {
        showSnackbar(message, "error");
    };

    const handleCancel = () => {
        setView("list");
        setEditingVehicle(null);
    };

    const handleAddVehicle = () => {
        navigate(`/manage-vehicle/add`, {
            state: {
                vehicleType,
                // driverList,
                encodedFormId,
            },
        });
    };


    const handleEditVehicle = () => {
        navigate("/manage-vehicle/edit", {
            state: {
                vehicle: editingVehicle,
                vehicleType,
                // driverList,
            },
        });
    };

    return (
        <Container >
            <Box
                sx={{
                    backgroundColor: '#0B1F40', // dark navy blue
                    padding: '12px 24px',
                    boxShadow: 3,
                    borderRadius: '4px 4px 0 0',
                    margin: '2px auto',
                    maxWidth: "100%",
                }}
            >
                <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
                    Vehicle Management  <InfoIcon onClick={() => setShowUserGuide(true)} style={{ "opacity": "0.6" }} />

                </Typography> </Box>

            <Dialog
                open={showUserGuide}
                onClose={() => setShowUserGuide(false)}
                maxWidth="sm"
                fullWidth
                sx={{
                    "& .MuiDialog-paper": {
                        borderRadius: "12px",
                        boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                        backgroundColor: "#f9fafb",
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        background: "linear-gradient(90deg, #1898c2 0%, #beab6c 100%)",
                        color: "white",
                        fontWeight: "bold",
                        textAlign: "center",
                        borderRadius: "12px 12px 0 0",
                        py: 2,
                    }}
                >
                    Fee Deposit User Guide
                </DialogTitle>
                <DialogContent sx={{ padding: "24px" }}>
                    <Typography
                        variant="h6"
                        sx={{
                            color: "#1898c2",
                            fontWeight: "600",
                            mb: 2,
                            mt: 1,
                            textAlign: "center",
                        }}
                    >
                        Quick Steps to Manage Vehicles
                    </Typography>
                    <Box
                        component="ul"
                        sx={{
                            listStyleType: "none",
                            padding: 0,
                            "& li": {
                                display: "flex",
                                alignItems: "flex-start",
                                mb: 1.5,
                                fontSize: "0.9rem",
                                color: "#333",
                            },
                            "& li::before": {
                                content: '"\\2022"', // Bullet point
                                color: "#1898c2",
                                fontWeight: "bold",
                                display: "inline-block",
                                width: "1.5em",
                                mr: 1,
                                fontSize: "1.2rem",
                            },
                            "& strong": {
                                margin: "0 0.2em", // Add spacing around strong tags
                            },
                        }}
                    >
                        <li><strong>Search Vehicles</strong> - Use the search bar to filter by vehicle number</li>
                        <li><strong>Add New</strong> - Click "Add Vehicle", enter details, and save</li>
                        <li><strong>Edit</strong> - Click the <EditIcon /> icon to modify vehicle information</li>
                        <li><strong>Deactivate</strong> - Click "Deactivate" to disable active vehicles</li>
                        <li><strong>Delete</strong> - Click <DeleteIcon /> to permanently remove (requires permission)</li>
                        <li><strong>View Status</strong> - Check "Active/Inactive" status in the table</li>
                        <li><strong>Navigate</strong> - Use pagination controls at the bottom for large lists</li>

                    </Box>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
                    <StyledButton
                        onClick={() => setShowUserGuide(false)}
                        color="primary"
                        variant="contained"
                        sx={{
                            backgroundColor: "#1898c2",
                            "&:hover": { backgroundColor: "#156f9a" },
                            borderRadius: "8px",
                            px: 4,
                        }}
                    >
                        Close
                    </StyledButton>
                </DialogActions>
            </Dialog>

            <Paper elevation={3} style={{ padding: "20px", marginTop: 6 }}>
                {/* Filters */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap">
                    {/* Left Side - Search and Dropdown */}
                    <Box display="flex" gap={2} flexWrap="wrap">
                        <TextField
                            label="Search Vehicle No"
                            name="searchTerm"
                            value={filters.searchTerm}
                            onChange={handleFilterChange}
                            style={{ width: "300px" }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <FormControl size="small" sx={{ minWidth: 140 }}>
                            <InputLabel id="filter-active-label" shrink>
                                Status
                            </InputLabel>
                            <Select
                                labelId="filter-active-label"
                                name="isActive"
                                value={filters.isActive || ""}
                                label="Status"
                                onChange={handleFilterChange}
                                displayEmpty
                                sx={{ height: "55px" }}
                                renderValue={(selected) => {
                                    if (selected === "") return "All";
                                    return selected === "true" ? "Active" : "Inactive";
                                }}
                            >
                                <MenuItem value="">All</MenuItem>
                                <MenuItem value="true">Active</MenuItem>
                                <MenuItem value="false">Inactive</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    {/* Right Side - Add Button */}
                    <Button variant="contained" color="primary" onClick={handleAddVehicle} style={{
                        width: "120px",
                        height: "50px",
                        padding: "10px 0",
                        fontWeight: 'bold'
                    }}
                    >
                        Add Vehicle
                    </Button>
                </Box>

                {/* Table */}
                <TableContainer
                    component={Paper}
                    style={{

                        marginTop: "16px",
                        border: '1px solid #ccc'
                    }}
                >
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#f5f5f5' }}>
                                    Vehicle No
                                </TableCell>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#f5f5f5' }}>
                                    Make
                                </TableCell>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#f5f5f5' }}>
                                    Seating Capacity
                                </TableCell>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#f5f5f5' }}>
                                    Insurance Due On
                                </TableCell>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#f5f5f5' }}>
                                    Status
                                </TableCell>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#f5f5f5', textAlign: 'center' }}>
                                    Actions
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading ? (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        <CircularProgress />
                                    </TableCell>
                                </TableRow>
                            ) : filteredVehicles.length > 0 ? (
                                filteredVehicles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                                    <TableRow key={row.vechileID} sx={{ borderTop: '1px solid #ccc' }}>
                                        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.vechileNo}</TableCell>
                                        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.make}</TableCell>
                                        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.seatingCapicity}</TableCell>
                                        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{new Date(row.insDueOn).toLocaleDateString()}</TableCell>
                                        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.vechileOn ? "Active" : "Inactive"}</TableCell>
                                        <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #ccc', fontSize: '1rem' }}>
                                            <Tooltip title={canEdit ? "Edit Vehicle" : "Not authorized to Edit"} arrow>
                                                <span>
                                                    <IconButton color="primary" onClick={() => handleEdit(row)} disabled={!canEdit}>
                                                        <EditIcon />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                            <Tooltip title={canDelete ? "Delete Vehicle" : "Not authorized to delete"} arrow>
                                                <span>
                                                    <IconButton color="error" onClick={() => handleDeleteClick(row)} disabled={!canDelete}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                            {row.vechileOn ? (
                                                <Button
                                                    variant="outlined"
                                                    color="error"
                                                    onClick={() => handleDisable(row)}
                                                >
                                                    Deactivate
                                                </Button>
                                            ) : (
                                                <Typography variant="body2" color="textSecondary">
                                                    Inactive
                                                </Typography>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        No Vehicles Found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>

                    </Table>
                </TableContainer>

                <TablePagination
                    component="div"
                    count={filteredVehicles.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                />
            </Paper>

            {/* Delete Confirmation Dialog */}
            <Modal open={deleteDialogOpen} onClose={handleDeleteCancel} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        overflow: 'hidden',
                    }}
                >
                    {/* Header */}
                    <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
                        <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
                            Delete Confirmation ⚠️
                        </Typography>
                    </Box>

                    {/* Content */}
                    <Box sx={{ padding: '20px' }}>
                        <Typography id="delete-modal-description" sx={{ mb: 2 }}>
                            Are you sure you want to delete this Vehicle ?
                        </Typography>

                        {/* Buttons */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                            <Button onClick={handleDeleteCancel} variant="outlined" sx={{ mr: 1 }}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={handleDeleteConfirm}
                            >
                                Yes, Delete
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>


            {/* Snackbar Notification */}


            <Snackbar
                open={openDeleteSnackbar}
                autoHideDuration={4000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>



        </Container>
    );
};

export default ManageVehicle;